import { useFormikContext } from "formik";
import Input from "./Input";

interface FormFieldProps {
  label: string;
  name: string;
  type?: string;
  forgotLink?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

/**
 * Formik-bound text field. Validation surfaces on BLUR (not while typing):
 * the error only shows once the user leaves a field, then updates live as
 * they fix it. Space for the message is reserved so the form never jumps.
 */
export default function FormField({
  label,
  name,
  type,
  forgotLink,
  placeholder,
  disabled,
}: FormFieldProps) {
  const { handleChange, handleBlur, values, errors, touched } =
    useFormikContext<Record<string, unknown>>();

  // Only show the error after the field has been blurred (touched), and only
  // when it's a plain string message. Formik re-validates on change, so once
  // touched the error clears live as the user corrects the value.
  const rawError = touched[name] ? errors[name] : undefined;
  const error = typeof rawError === "string" ? rawError : undefined;

  return (
    <Input
      id={name}
      name={name}
      type={type}
      value={(values[name] as string) ?? ""}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
      label={label}
      error={error}
      forgotLink={forgotLink}
      disabled={disabled}
    />
  );
}
